import { requestHttp } from "../utils/HttpRequest";

export const getOrderMetrics = (idUser, date) => {
  try {
    const response = requestHttp({
      endpoint: "order_metrics",
      data: {
        user_id: idUser,
        chosen_date: date,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
